<script>
  import { createEventDispatcher } from "svelte";

  import { formatEther } from "viem";
  import { writeContract, getPublicClient } from '@wagmi/core';

  import { chainSymbol, chainExplorer, walletAddress } from "../stores.js";
  import { getABI, getContractValue } from "../utils.js";

  export let chain;
  export let address;

  let amount;

  let withdrawing = false;
  let txHash;
  let feedback;

  $: $walletAddress, init();

  const init = async () => {
    if ($walletAddress) {
      amount = await getContractValue(chain, address, 'releasable', [ $walletAddress ]);
    }
  }

  const withdraw = async () => {
    withdrawing = true;
    try {
      const { hash } = await writeContract({
        chainId: chain, address, abi: await getABI(address, chain),
        functionName: 'release', args: [ $walletAddress ]
      });
      txHash = hash;
    } catch (err) {
      if (err.shortMessage === 'User rejected the request.') {
        dispatch('user-cancel');
        new CustomEvent('user-cancel');
        withdrawing = undefined;
      } else { console.log(err) }
    }
    dispatch('hashed', txHash);
    new CustomEvent('hashed', { detail: txHash });
    const receipt = await getPublicClient().waitForTransactionReceipt({ hash: txHash });
    feedback = 'Released';
    setTimeout(() => { feedback = undefined }, 5 * 1000)
    dispatch('released', receipt)
    new CustomEvent('released', { detail: receipt });
    txHash = undefined;
    withdrawing = undefined;
  }

  const dispatch = createEventDispatcher();
</script>

{#if amount}
  {#if feedback}
    <span class="lt-withdraw feedback">{ feedback }</span>
  {:else if txHash}
    <a href="{ $chainExplorer.url }/tx/{ txHash }" target="_blank" class="lt-withdraw txHash">View Tx</a>
  {:else}
    <button class={ $$props.class } class:lt-withdraw={ true } type="button" on:click={ withdraw }>
      {#if withdrawing}
        <span class="lt-withdraw loading"></span>
      {/if}
      <slot>
        <span class="amount">
          { new Intl.NumberFormat('default', { maximumSignificantDigits: 4 }).format(formatEther(amount)) }
        </span>
        <slot name="symbol">{ $chainSymbol }</slot>
      </slot>
    </button>
  {/if}
{/if}